import React, { Component } from 'react';
import Button from './Button';
import './PopUpSelect.css';

class PopUpSelect extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedItem: null,
			item: this.props.item,
		};
	};

	handleClick = (value) => {
		this.props.handleChangeItemState(value);
	}

	handleOnBlur = () => {
		this.props.onBlur();
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.item != nextState.item) {
			this.setState({
				item: nextProps.item,
			})
		}

		return true;
	}

	render() {
		let style = {
			position: 'absolute',
			backgroundColor: 'white',
			left: this.props.left,
			borderRadius: '4px',
			boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2)',
			overflow: 'auto',
			height: 250,
		};

		if (this.props.bottom != null) {
			style.bottom = this.props.bottom;
		} else if (this.props.top != null) {
			style.top = this.props.top;
		}

		let liStyle = {
			cursor: 'pointer',
			listStyle: 'none',
			fontFamily: 'Arial',
			color: '#5a5a5a',
			padding: 6,
			':hover': {
				opacity: 0.7,
				backgroundColor: '#cac9c9',
			},
		}

		style = Object.assign(style, this.props.style);

		var handleChangeItemState = this.props.handleChangeItemState;
		if (this.props.isPopUp) {
			style.position = 'absolute';
		} else {
			style.position = 'relative';
		}

		let bgColor = 'white';
		if (this.props.bgColor != null) {
			bgColor = this.props.bgColor
		}

		return (
			<div style={{ position: 'relative' }}>
				<div style={style} className='popupselect'>
					{this.state.item.map((item, i) => {
						return <li
							style={{ ...liStyle, backgroundColor: item.isChecked ? 'rgba(142, 142, 142, 0.54)' : bgColor }}
							key={item.key + '_' + i}
							value={item.key}
							onClick={() => this.handleClick(item.key)}
							tagindex={i}
							onBlur={this.handleOnBlur}
						>
							{
								this.props.propType == 'multiStateIcon' ? (<img src={item.display} alt='' style={{ maxWidth: '60px' }} />) : item.display
							}
						</li>
					})}
				</div>
			</div>
		);
	}
}

export default PopUpSelect;